export const catchPromiseCancel = (err: unknown): void => {
  if ((err as Error)?.message?.match('canceled')) {
    return
  } else {
    throw err
  }
}
